import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d4307cd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ncgr-interactive-list" }
const _hoisted_2 = ["id", "checked"]
const _hoisted_3 = ["for"]
const _hoisted_4 = { class: "_body" }
const _hoisted_5 = { class: "_title" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_trailing" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "_icon" }, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "ncgr-icon",
      "data-icon": "chevron_down"
    })
  ])
], -1))
const _hoisted_7 = { class: "_content" }
const _hoisted_8 = { class: "scrollable" }
const _hoisted_9 = { class: "ncgr-table ncgr-mar-b-24" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"64px"} }, " 販売枚数 "),
  /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"88px"} }, [
    /*#__PURE__*/_createTextVNode(" SUZURIからの"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("提供価格 ")
  ]),
  /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"148px"} }, " トリブン単価 "),
  /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"160px"} }, " 印刷方法 ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.table, (level, i) => {
      return (_openBlock(), _createElementBlock("li", {
        key: level.screenCount,
        class: "_item"
      }, [
        _createElementVNode("input", {
          id: `${_ctx.itemName}-${level.screenCount}`,
          class: "_input",
          type: "checkbox",
          checked: i === 0
        }, null, 8, _hoisted_2),
        _createElementVNode("label", {
          for: `${_ctx.itemName}-${level.screenCount}`
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, " インク" + _toDisplayString(level.screenCount) + "色で作成した場合 ", 1)
          ]),
          _hoisted_6
        ], 8, _hoisted_3),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("table", _hoisted_9, [
              _createElementVNode("tbody", null, [
                _hoisted_10,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(level.thresholds, (threshold, j) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: threshold.salesCount
                  }, [
                    _createElementVNode("td", null, [
                      _createTextVNode(_toDisplayString(threshold.salesCount) + "〜", 1),
                      (level.thresholds[j+1])
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(level.thresholds[j+1].salesCount - 1), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(_ctx.formatPrice(threshold.offerPrice)), 1),
                    _createElementVNode("td", null, " (設定価格) + " + _toDisplayString(_ctx.formatPrice(threshold.bonus)), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$t(`printing-method.${threshold.printingMethod}`)), 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ]))
    }), 128))
  ]))
}